import Aura from '@primeuix/themes/aura'
import { auth0 } from '@/plugins/auth0'
import Config from '@serv/Config'
import { createPinia } from 'pinia'
import createRouter from '@src/router'
import LoadScript from 'vue-plugin-load-script'
import mixpanel from './mixpanel.js'
import { piniaResetPlugin } from './piniaResetStore'
import PrimeVue from 'primevue/config'
import store from '@src/store'
import SuiVue from 'semantic-ui-vue'
import vuetify from './vuetify'
import { browserProfilingIntegration, BrowserTracing, init, vueRouterInstrumentation } from '@sentry/vue'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'


export const pinia = createPinia()

pinia.use(piniaResetPlugin)

export function registerPlugins(app) {
    const router = createRouter(app)

    app.use(PrimeVue, {
        theme: {
            preset: Aura,
            options: {
                darkModeSelector: false,
                cssLayer: {
                    name: 'primevue',
                    order: 'theme, base, vuetify, primevue, overrides'
                }
            }
        }
    })

    /* Tanstack query client */
    const queryClient = new QueryClient()

    app.use(vuetify).use(LoadScript).use(SuiVue).use(store).use(VueQueryPlugin, { queryClient })

    if (import.meta.env.VITE_SENTRY != 'off') {
        init({
            app,
            dsn: 'https://23ca995b381b4aaea598514780858349@o125350.ingest.sentry.io/287515',
            environment: Config.environment,
            integrations: [
                new BrowserTracing({
                    routingInstrumentation: vueRouterInstrumentation(router)
                }),
                browserProfilingIntegration()
            ],
            replaysSessionSampleRate: 1,
            replaysOnErrorSampleRate: 1,
            tracesSampleRate: 0.5,
            profilesSampleRate: 1.0,
            denyUrls: [/dev\./, /demo\./, /myrecoverytest\.com/],
            allowUrls: [/myrecovery\.ai/, /msk\.ai/],
            beforeSend(event) {
                if (event.exception?.values) {
                    const exception = event.exception.values[0]

                    if (exception.stacktrace?.frames) {
                        const frames = exception.stacktrace.frames
                        if (frames[frames.length - 1]?.filename?.includes('Logging.js')) {
                            frames.pop()
                        }
                    }
                }

                return event
            }
        })
    }

    if (window.location.pathname.includes('auth')) {
        app.use(auth0)
    }

    app.use(pinia)
    app.use(router)

    app.provide('$mp', import.meta.env.VITE_MIXPANEL === 'on' ? mixpanel : null)
}
